import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Main from "./pages/main/Main";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import SignIn from "./pages/signin/SignIn";
import ForgotPassword from "./pages/forgot-password/ForgotPassword";
import ResetPassword from "./pages/forgot-password/ResetPassword";
import TermsAndConditions from "./components/terms/TermsAndConditions";
import Privacy from "./components/terms/Privacy";
import CustomizationHome from "./pages/customization/Home/CustomizationHome";
import CreateCustomization from "./pages/customization/Create/CreateCustomization";
import EditCustomization from "./pages/customization/Edit/EditCustomization";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route
            path="/redp/:user_id"
            element={
              <ProtectedRoute>
                <Main />
              </ProtectedRoute>
            }
          />

          <Route
            path="/redp/:user_id/customizations"
            element={
              <ProtectedRoute>
                <CustomizationHome />
              </ProtectedRoute>
            }
          />

          <Route
            path="/redp/:user_id/customizations/create-customization"
            element={
              <ProtectedRoute>
                <CreateCustomization />
              </ProtectedRoute>
            }
          />

          <Route
            path="/redp/:user_id/customizations/:customizationId"
            element={
              <ProtectedRoute>
                <EditCustomization />
              </ProtectedRoute>
            }
          />



        </Routes>
        
      </Router>
    </AuthProvider>
  );
}

export default App;
